module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Clipboard-check-aaebe5f5d91761a80cf2c643b7d1aaa2.svg";